import React, { useState } from 'react';
import { Offcanvas, OffcanvasBody, OffcanvasHeader } from 'reactstrap';
import AllProducts from '../AllProducts';
import SingleProduct from '../SingleProduct';

const RejectedListings = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');

    const toggleCanvas = () => {
        setIsOpen(!isOpen);
    };

    const handleRefresh = () => {
        setRefreshKey(prevKey => prevKey + 1);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleProductClick = (product) => {
        setSelectedProduct(product);
        setIsOpen(true);
    };

    return (
        <>
            <div className='d-flex align-items-center justify-content-between mb-4'>
                <h2>Rejected Listings</h2>
                <div className='d-flex align-items-center justify-content-end'>
                    <div className="me-3">
                        <input
                            type="text"
                            className="form-control w-300px rounded-50 ps-3"
                            style={{ height: '50px' }}
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearchChange}
                        />
                    </div>
                </div>
            </div>

            <AllProducts
                key={refreshKey}
                searchQuery={searchQuery}
                statusFilter="rejected"
                onProductClick={handleProductClick}
            />

            <Offcanvas isOpen={isOpen} toggle={toggleCanvas} className="custom-canvas-width" direction='end'>
                <OffcanvasHeader className='mb-4 mx-4 mt-2 border-bottom' toggle={toggleCanvas}>
                    <span className='font-weight-bold'>{selectedProduct?.title || 'Product Details'}</span>
                </OffcanvasHeader>
                <OffcanvasBody>
                    <SingleProduct product={selectedProduct} onSuccess={handleRefresh} />
                </OffcanvasBody>
            </Offcanvas>
        </>
    );
};

export default RejectedListings;

